import { nextTick } from 'vue';

/**
 * @param {string} name
 * @returns {string}
 */
export function categoryDomId(name) {
	return name.replace(/\s+/g, '-').toLowerCase();
}

/**
 * @param {string} id
 * @param {number} timeoutMs
 * @returns {Promise<HTMLElement | null>}
 */
function waitForElement(id, timeoutMs) {
	return new Promise((resolve) => {
		let start = performance.now();

		function tick() {
			let el = document.getElementById(id);
			if (el || performance.now() - start >= timeoutMs) {
				resolve(el);
				return;
			}
			requestAnimationFrame(tick);
		}

		requestAnimationFrame(tick);
	});
}

/**
 * Scroll to a Results.vue category heading after a store update.
 * Results uses a 200ms out-in transition, so the node often is not mounted yet
 * when navigateCategory() resolves.
 *
 * @param {string} name
 * @param {{ timeoutMs?: number }} [options]
 */
export async function scrollToCategoryHeading(name, { timeoutMs = 500 } = {}) {
	let id = categoryDomId(name);
	await nextTick();

	let el = document.getElementById(id) ?? await waitForElement(id, timeoutMs);
	el?.scrollIntoView();
}
